import React, {useRef, useEffect} from 'react'
import Chart from 'chart.js'
import {palette} from "./chartUtils";

const BarChart = ({xAxis, yAxis, label = '', ySet, xSet}) => {
    const barCanvas = useRef()

    useEffect(() => {
        const chart = new Chart(barCanvas.current, {
            type: 'bar',
            options: {
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        },
                        scaleLabel: {
                            display:  ySet || xSet,
                            labelString: ySet
                        }
                    }],
                    xAxes: [{
                        scaleLabel: {
                            display: ySet || xSet,
                            labelString: xSet
                        }
                    }],
                },
                tooltips: {
                    callbacks: {
                        label: (tooltip, data) => {
                            const currentDataIndex = tooltip.index
                            const {datasets} = data
                            const text = Number(datasets[0].data[currentDataIndex])
                            return text.toLocaleString()
                        }
                    }
                }
            },
            data: {
                labels: xAxis,
                datasets: [
                    {
                        label: label,
                        data: yAxis,
                        borderColor: 'rgba(143,154,172,0.78)',
                        backgroundColor: palette,
                        borderWidth: 1,
                        barThickness: 'flex',
                        maxBarThickness: 100,
                        fill: true
                    }
                ]
            }
        })

        return () => chart.destroy();
    }, [xAxis, yAxis])

    return (
        <React.Fragment>
            <canvas ref={barCanvas}/>
        </React.Fragment>
    )
}
export default BarChart